import { render } from "./faq1Page.vue?vue&type=template&id=454a51f3"
import script from "./faq1Page.vue?vue&type=script&lang=js"
export * from "./faq1Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__